<template>
    <div class="snippet-preview-wrapper border rounded position-relative" style="background: #fafafa; min-height: 200px;">
        <!-- 이미 그린 미리보기는 다시 그리는 동안에도 유지하고 배지만 띄운다(타이핑 중 깜빡임 방지) -->
        <b-badge v-if="loading && renderedHtml" variant="secondary" class="preview-updating">갱신 중</b-badge>
        <div v-if="loading && !renderedHtml" class="d-flex align-items-center justify-content-center" style="height: 200px;">
            <b-spinner variant="primary" />
        </div>
        <div v-else-if="error" class="text-danger p-2">
            <small>미리보기 오류: {{ error }}</small>
        </div>
        <div v-else-if="!content" class="d-flex align-items-center justify-content-center text-muted" style="height: 200px;">
            <small>내용을 입력하면 미리보기가 표시됩니다.</small>
        </div>
        <iframe
            v-else
            ref="iframe"
            class="snippet-preview-iframe"
            :srcdoc="renderedHtml"
            sandbox="allow-same-origin"
            @load="adjustHeight"
        />
    </div>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
export default {
    name: 'SnippetPreview',
    props: {
        content: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            renderedHtml: '',
            loading: false,
            error: null,
            renderSeq: 0,   // 마지막 요청 응답만 반영 — 늦게 온 이전 입력의 미리보기가 덮지 않게
        };
    },
    watch: {
        content: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.renderSeq++;
                    this.renderedHtml = '';
                    this.loading = false;
                    this.error = null;
                    return;
                }
                this.renderPreview(val);
            }
        }
    },
    methods: {
        async renderPreview(content) {
            const seq = ++this.renderSeq;
            this.loading = true;
            this.error = null;
            try {
                const resp = await this.$axios.post('/mail/render-preview', { template: content });
                if (seq !== this.renderSeq) return;
                this.renderedHtml = typeof resp.data === 'string' ? resp.data : ((resp.data && resp.data.html) || '');
            } catch (e) {
                if (seq !== this.renderSeq) return;
                this.error = getErrorMessage(e, '렌더링 실패');
            } finally {
                if (seq === this.renderSeq) this.loading = false;
            }
        },
        adjustHeight() {
            const iframe = this.$refs.iframe;
            if (!iframe || !iframe.contentDocument) return;
            const h = iframe.contentDocument.documentElement.scrollHeight;
            iframe.style.height = (h + 16) + 'px';
        },
    }
};
</script>

<style scoped>
.snippet-preview-iframe {
    width: 100%;
    border: 0;
    background: #fff;
    min-height: 200px;
    display: block;
}
.preview-updating {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 1;
}
</style>
